import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-support-new',
  templateUrl: './support-new.component.html',
  styleUrls: ['./support-new.component.css']
})
export class SupportNewComponent implements OnInit {
	sKey: string = null;
	environment:string = null;
  Name: string = "";
  LastName: string = "";
  Email: string = "";
  Mobile: string = "";
  hideSideMenu = false;
  Message: string = "";
  reCaptcha: string = null;
  terms: string = null;
  aUser: any = {};
  public getScreenWidth: any;
  public getScreenHeight: any;
  isPhonePortrait = false;

  constructor( public authWebService: AuthWebService,private toastService:ToastNotificationService, private toastr:ToastrService ,private responsive: BreakpointObserver) { }

  ngOnInit(): void {
    this.sKey = environment.captcha.siteKey;
    this.responsive.observe([
      Breakpoints.HandsetLandscape,      
      Breakpoints.TabletLandscape,
      ])
      .subscribe(result => {

        this.hideSideMenu = false; 
        this.isPhonePortrait = false; 

        if (result.matches) {
          this.hideSideMenu = true;
          this.isPhonePortrait = true;
        }

  });
  }

  getSiteKey(){
    return this.sKey
  }

  submit(){

      //Validation
      let returnedErrors = this.validate();
      if(returnedErrors.length > 0){
      return this.toastService.error(returnedErrors,'Submission failed');
      }

      //Send Emails
      this.aUser.FirstName = this.Name;
      this.aUser.LastName = this.LastName;
      this.aUser.EmailAddress = this.Email;
      this.aUser.PhoneNumber = this.Mobile;
      this.aUser.Note = this.Message;

      this.authWebService.sendSupportEmails(this.aUser);
      //this.toastService.success("The support email has been sent",'Success')
  }
  
  validate() {
    var msg: string = "";
    var count: number = 1;
  
      if(this.Name.length == 0){
      msg += "\n" + count + ". Name is required! ";
      count++;
      }
  
      if(this.LastName.length == 0){
      msg += "\n" + count + ". Last name is required! ";
      count++;
      }

    if(this.Email.length == 0){
    msg += "\n" + count + ". Email is required! ";
    count++;
    }
  
    if(this.Mobile.length == 0){
    msg += "\n" + count + ". Mobile Number is required! ";
    count++;
    }

    if(this.Message.length == 0){
      msg += "\n" + count + ". What can we help you with? ";
      count++;
      }

  if (this.reCaptcha === null && this.environment != 'qa' && this.environment != 'dev'){
  msg += count + ". Click on I am not a robot \n";
  count++;
  }

        if (this.terms === null){
      msg += count + ".  Please click POPIA Processing Notice \n";
      count++;
      }

    return msg;
  }

  resolved(captchaResponse: string){
    //console.log(captchaResponse)
    this.reCaptcha = captchaResponse;
  }

  ckeckTerms(event){
    if ( event.target.checked ) {

    this.terms = 'clicked'
    }
    }

      
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
  }
  

}
